import {
	call, delay, put, race, takeEvery,
} from "redux-saga/effects";
import {
	ActionsReview,
	failureReview,
	loadReviewSuccess,
	loadGetReview,
} from "./actions";
import Env from "../../../consts/env";

function* loadDataReview(params = {}) {

	try {

		yield put(loadGetReview());

		const endpoint = `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/api-new/getNewestReview/?${params.next_id ? `next_id=${params.next_id}` : `page=${params.page}`}&limit=${params.limit}&type=${params.type_review}`;
		const headers = {
			...Env.HEADERS,
			Authorization: params.Authorization,
		};

		const method = "GET";
		const options = { headers, method };

		const { timeout, response } = yield race({
			timeout: delay(Env.REQUEST_TIMEOUT),
			response: call(fetch, endpoint, options),
		});

		if (timeout) {

			yield put(failureReview(yield "Error Timeout..."));

		} else {

			if (response.status < 200 && response.status >= 300) {

				throw new Error("Error fetching data");

			}

			const dataReview = yield response.json();

			if (dataReview.meta.code < 200 && dataReview.meta.code > 300) {

				yield put(failureReview(yield response.statusText));

			} else {

				yield put(loadReviewSuccess(yield dataReview));

			}

		}

	} catch (err) {

		yield put(failureReview(err));

	}

}

export default function* rootSaga() {

	yield takeEvery(ActionsReview.GET_REVIEW, loadDataReview);

}
